<template>
    <tr>
        <td data-label="Status">
            <span v-if="status === 'error'" @click="onLabelClick">
                <tooltip-info :text="promo.description" :content="true">
                    <label-state
                        :state="promo.label"
                        :show-tooltip="false"
                        :show-icon="!!promo.description"
                    />
                </tooltip-info>
            </span>
            <span v-else>
                <label-state :state="status" />
            </span>
        </td>
        <td data-label="Produkt">
            <router-link
                :to="`/promo-details/${promo.id}`"
                class="font-weight-bold"
                @click.native="closeModal"
            >{{ promo.name }}</router-link>
        </td>
        <td data-label="Sklep">
            {{ setShopLabel }}
            <a-icon
                v-if="$store.getters.isMerchantDiagnosticInvalid(locationId)"
                v-tooltip="
                    'Przynajmniej jedno urządzenie fiskalne w tym sklepie nie jest połączone z serwerem.'
                "
                class="text-danger ml-1"
                style="width: 16px; height: 16px; position: relative; top: 3px;"
                icon="WarningFull"
            />
        </td>
    </tr>
</template>

<script>
import { wtMerchants } from '@/walkthroughs/wtData'

export default {
    props: {
        promo: {
            type: Object,
            required: true
        },
        status: {
            type: String,
            default: 'accepted'
        }
    },
    computed: {
        merchant() {
            if (this.$store.getters.getWalkthroughActive) {
                return wtMerchants.find(el => el.id === this.promo.merchant_id)
            } else {
                return this.$store.getters.getMerchantById(
                    this.promo.merchant_id
                )
            }
        },

        locationId() {
            return this.$store.getters.getMerchantById(this.promo.merchant_id)
                ?.location_id
        },

        setShopLabel() {
            const data = this.merchant
            return `${data.name}, ${this.$store.getters.getShopAddress(data)}`
        }
    },
    methods: {
        closeModal() {
            this.$store.dispatch('toggleModal', false)
        },
        onLabelClick() {
            // eslint-disable-next-line camelcase
            if (this.promo.detail?.conflicting_promo_id) {
                this.$router.push(
                    `/promo-details/${this.promo.detail.conflicting_promo_id}`
                )
                this.closeModal()
            }
        }
    }
}
</script>
